/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Topics,
  Topics$inboundSchema,
  Topics$Outbound,
  Topics$outboundSchema,
} from "./topics.js";
import {
  WebhookConfig,
  WebhookConfig$inboundSchema,
  WebhookConfig$Outbound,
  WebhookConfig$outboundSchema,
} from "./webhookconfig.js";
import {
  WebhookCredentialsUpdate,
  WebhookCredentialsUpdate$inboundSchema,
  WebhookCredentialsUpdate$Outbound,
  WebhookCredentialsUpdate$outboundSchema,
} from "./webhookcredentialsupdate.js";

export type DestinationUpdateWebhook = {
  /**
   * "*" or an array of enabled topics.
   */
  topics?: Topics | undefined;
  /**
   * Optional JSON schema filter for event matching. Events must match this filter to be delivered to this destination.
   *
   * @remarks
   * Supports operators: $eq, $neq, $gt, $gte, $lt, $lte, $in, $nin, $startsWith, $endsWith, $exist, $or, $and, $not.
   * If null or empty, all events matching the topic filter will be delivered.
   * To remove an existing filter when updating a destination, set filter to an empty object `{}`.
   */
  filter?: { [k: string]: any } | null | undefined;
  config?: WebhookConfig | undefined;
  credentials?: WebhookCredentialsUpdate | undefined;
  /**
   * Static key-value pairs merged into event metadata on every attempt.
   */
  deliveryMetadata?: { [k: string]: string } | null | undefined;
  /**
   * Arbitrary contextual information stored with the destination.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateWebhook$inboundSchema: z.ZodType<
  DestinationUpdateWebhook,
  z.ZodTypeDef,
  unknown
> = z.object({
  topics: Topics$inboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: WebhookConfig$inboundSchema.optional(),
  credentials: WebhookCredentialsUpdate$inboundSchema.optional(),
  delivery_metadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "delivery_metadata": "deliveryMetadata",
  });
});
/** @internal */
export type DestinationUpdateWebhook$Outbound = {
  topics?: Topics$Outbound | undefined;
  filter?: { [k: string]: any } | null | undefined;
  config?: WebhookConfig$Outbound | undefined;
  credentials?: WebhookCredentialsUpdate$Outbound | undefined;
  delivery_metadata?: { [k: string]: string } | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateWebhook$outboundSchema: z.ZodType<
  DestinationUpdateWebhook$Outbound,
  z.ZodTypeDef,
  DestinationUpdateWebhook
> = z.object({
  topics: Topics$outboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: WebhookConfig$outboundSchema.optional(),
  credentials: WebhookCredentialsUpdate$outboundSchema.optional(),
  deliveryMetadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    deliveryMetadata: "delivery_metadata",
  });
});

export function destinationUpdateWebhookToJSON(
  destinationUpdateWebhook: DestinationUpdateWebhook,
): string {
  return JSON.stringify(
    DestinationUpdateWebhook$outboundSchema.parse(destinationUpdateWebhook),
  );
}
export function destinationUpdateWebhookFromJSON(
  jsonString: string,
): SafeParseResult<DestinationUpdateWebhook, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationUpdateWebhook$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationUpdateWebhook' from JSON`,
  );
}
